// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__sY6SE","overflowing":"ReadFullNote_overflowing__2gdyr"};